import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractResultsViewData } from 'gql/graphql';
import type { DeepPartial } from 'types';

import type { Dispatch, SetStateAction } from 'react';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimFrameContractResultsGql } from '../BimContractRequests';

const requestId = `bimFrameContractResults`;

export const useBimFrameContractResults = (
    contractId: number,
    setFrameContractResults: Dispatch<SetStateAction<DeepPartial<BimContractResultsViewData> | undefined | null>>,
) => {
    const dispatch = useDispatch();

    const [bimFrameContractResultsData, bimFrameContractResultsStatus, , bimFrameContractResultsMakeRequest] =
        useRequest({
            requestId,
            query: bimFrameContractResultsGql,
            withEffect: false,
        });

    const [bimFrameContractResultsMakeReset] = useResetStoreData({ requestId });

    const bimFrameContractResultsRequest = useCallback(() => {
        bimFrameContractResultsMakeReset(undefined);

        dispatch(bimFrameContractResultsMakeRequest({ contractId }));
    }, [bimFrameContractResultsMakeRequest, bimFrameContractResultsMakeReset, contractId, dispatch]);

    useEffect(() => {
        if (bimFrameContractResultsData?.bimFrameContractResults?.result === true) {
            setFrameContractResults(bimFrameContractResultsData?.bimFrameContractResults?.data);
        }
    }, [
        bimFrameContractResultsData?.bimFrameContractResults?.data,
        bimFrameContractResultsData?.bimFrameContractResults?.result,
        setFrameContractResults,
    ]);

    useEffect(() => {
        bimFrameContractResultsMakeReset(undefined);
    }, [bimFrameContractResultsMakeReset]);

    return {
        bimFrameContractResultsStatus,
        bimFrameContractResultsRequest,
    };
};
